import api from '@/shared/api';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { EmployeeQueryKey } from './queryKey';
export const useGetTimeTable = (employeeId) => {
    const intl = useIntl();
    return useQuery([EmployeeQueryKey.TimeTable, employeeId], () => api.base
        .get(`/api/employee/TimeTable/${employeeId}`)
        .then(res => res.data || null), {
        enabled: !!employeeId,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export const useGetOvertimeRemaining = (employeeId, enabled) => {
    const intl = useIntl();
    return useQuery([EmployeeQueryKey.OvertimeRemaining, employeeId], () => api.base
        .get(`/api/employee/OvertimeRemaining/${employeeId}`)
        .then(res => res.data), {
        enabled: !!employeeId && enabled,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export const useDeleteTimeTable = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(employeeId => api.base
        .delete(`/api/employee/TimeTable/${employeeId}`)
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { deleteTimeTable: mutateAsync, isLoading };
};
